import { useNavigate, useSearchParams } from 'react-router-dom';

export const useNavigateWithSearch = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return (pathname?: string) =>
    navigate({
      pathname,
      search: searchParams.toString(),
    });
};
